import { ContactType } from '../common/interfaces/IContacts';

const renderContactType = (contactType?: ContactType) => {
    if (!contactType) {
        return '';
    }

    return contactType === ContactType.operational
        ? 'Operacional'
        : 'Comercial';
};

export default renderContactType;
